import { apiMapper } from "./ApiMapper";

const InvoiceAPI = {
  LIST: (axiosPrivate, clientID, pageNumber, pageSize) => {
    return axiosPrivate.get(
      `${apiMapper.invoiceAPI.list}${clientID}/?page=${pageNumber}&page_size=${pageSize}`
    );
  },
  INVOICE_TEMPLATE_LIST: (axiosPrivate) => {
    return axiosPrivate.get(`${apiMapper.invoiceAPI.invoiceTemplateList}`);
  },
  INVOICE_TEMPLATE_DELETE: (axiosPrivate, id) => {
    return axiosPrivate.delete(`${apiMapper.invoiceAPI.deleteTemplate}${id}`);
  },

  REGENERATE: (axiosPrivate, id, payload) => {
    return axiosPrivate.post(
      `${apiMapper.invoiceAPI.regenerate}${id}/`,
      payload
    );
  },
  PAID: (axiosPrivate, payload) => {
    return axiosPrivate.patch(apiMapper.invoiceAPI.paid, payload);
  },

  GENERATE_BY_AMOUNT: (axiosPrivate, payload) => {
    return axiosPrivate.patch(apiMapper.invoiceAPI.generateByAmount, payload);
  },
  SENDMAIL: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.invoiceAPI.sendMail, payload);
  },
  SAVE_TEMPLATE: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.invoiceAPI.saveTemplate, payload);
  },

  UPDATE_TEMPLATE: (axiosPrivate, payload, id) => {
    return axiosPrivate.put(
      `${apiMapper.invoiceAPI.saveTemplate}${id}`,
      payload
    );
  },

  FETCH_INVOICES: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.invoiceAPI.generateInvoice, payload);
  },
  GENERATE_INVOICE_PDF: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.invoiceAPI.generateInvoicePdf, payload);
  }
};
export default InvoiceAPI;
